import { useEffect, useRef, useState, useCallback } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Lenis from 'lenis';
import { Toaster } from 'sonner';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Marquee from './components/Marquee';
import Fleet from './components/Fleet';
import Partner from './components/Partner';
import Services from './components/Services';
import Photoshoot from './components/Photoshoot';
import VehicleServices from './components/VehicleServices';
import WhyUs from './components/WhyUs';
import Experience from './components/Experience';
import Testimonials from './components/Testimonials';
import Faq from './components/Faq';
import Reserve from './components/Reserve';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Admin from './components/Admin';
import './App.css';

function Site() {
  const lenisRef = useRef(null);
  const [vehicle, setVehicle] = useState('');

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    lenisRef.current = lenis;
    let raf;
    const loop = (t) => { lenis.raf(t); raf = requestAnimationFrame(loop); };
    raf = requestAnimationFrame(loop);
    return () => { cancelAnimationFrame(raf); lenis.destroy(); };
  }, []);

  const navigate = useCallback((href) => {
    const el = document.querySelector(href);
    if (!el) return;
    if (lenisRef.current) lenisRef.current.scrollTo(el, { offset: -70, duration: 1.4 });
    else el.scrollIntoView({ behavior: 'smooth' });
  }, []);

  const reserveVehicle = useCallback((name) => {
    setVehicle(name);
    navigate('#reserve');
  }, [navigate]);

  return (
    <div className="grain bg-ink font-body text-white antialiased">
      <Navbar onNavigate={navigate} />
      <main>
        <Hero onNavigate={navigate} />
        <Fleet onReserve={reserveVehicle} />
        <Partner />
        <Marquee />
        <Services />
        <Photoshoot />
        <VehicleServices />
        <WhyUs />
        <Experience />
        <Testimonials />
        <Faq />
        <Reserve selectedVehicle={vehicle} />
        <Contact />
      </main>
      <Footer onNavigate={navigate} />
      <Toaster theme="dark" position="bottom-right" toastOptions={{ style: { background: '#1A1A1A', border: '1px solid rgba(200,168,93,0.3)', color: '#fff' } }} />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Site />} />
        <Route path="/admin" element={<Admin />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
